import { Typography } from '@mui/material'
import { Modal } from '../../customComponents/Modal'

interface Props {
  onClose: () => void
  onConfirm: () => void
}

export function BudgetThresholdExceededModal (props: Props): JSX.Element {
  return <Modal
    open={true}
    maxWidth='sm'
    title={'Budget Change Exceeds Threshold'}
    confirmButtonText='Save'
    data-testid='budgetExceededModal'
    bodyContent={<>
      <Typography variant='body1'>Any individual or cumulative budget update that changes the allocation of contract funds within budget categories by more than 10% requires approval from START.</Typography>
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>Your budget revisions exceed this 10% threshold.</Typography>
      <Typography variant='body1'>Please confirm and submit your updates, or cancel to make further adjustments before proceeding.</Typography>
    </>}
    onClose={props.onClose}
    onConfirm={props.onConfirm}
  />
}
